import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact, { BugsnagPluginReactResult } from "@bugsnag/plugin-react";
import { shouldIgnoreError } from "./lib/utils";
import { WretchError } from "wretch/resolver";
import { ChunkErrorProvider } from "./providers/chunk-error";

Bugsnag.start({
    apiKey: "5e64b15d7da82011cc39319f96ef7762",
    plugins: [new BugsnagPluginReact()],
    enabledReleaseStages: ["production", "staging"],
    onError(event) {
        // Filter out non-actionable errors
        const IGNORED_CODES = [400, 401, 403, 504];
        if (event.errors.some((e) => e instanceof WretchError && IGNORED_CODES.includes(e.status ?? 0))) {
            return false;
        }
        if (event.errors.some((e) => shouldIgnoreError(e))) {
            return false;
        }

        return true;
    },
});

const ErrorBoundary = (Bugsnag.getPlugin("react") as BugsnagPluginReactResult).createErrorBoundary(React);

ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
        <ChunkErrorProvider>    
            <ErrorBoundary>
                <App />
            </ErrorBoundary>
        </ChunkErrorProvider>
    </React.StrictMode>
);
